<template>
    <div>
        <div class="budinessFlow">
            <h2>◆租赁流程</h2>
            <h3>1、签约注册：</h3>
            <p>客户根据业务需求，与普拉托签订《租赁服务协议》，并在普拉托运营的“普托e享”专用系统注册账号，用于业务操作。</p>
            <h3>2、起租申请：</h3>
            <p>客户通过合同约定方式向普拉托提出托盘起租申请；</p>
            <h3>3、物流配送：</h3>
            <p>普拉托确认起租需求后，安排车辆将租赁托盘配送至客户指定地点，客户也可选择自行到普拉托营运服务中心提取托盘；</p>
            <h3>4、退租申请：</h3>
            <p>客户通过合同约定方式向普拉托提出托盘退租申请；</p>
            <h3>5、物流回收：</h3>
            <p>普拉托确认退租需求后，安排车辆从客户指定地点回收租赁托盘，客户也可选择自行归还托盘到普拉托营运服务中心；</p>
            <h3>6、对账结算：</h3>
            <p>租赁期内，客户全部租赁合约按月度进行对账结算。</p>
        </div>

    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.budinessFlow {
    border: 1px solid #ccc;
    padding: 20px 20px 160px 20px;
    h2 {
        margin: 20px 0;
    }
    h3{
        margin: 10px 0;
    }
    p{
        text-indent:1em
    }
}
</style>